/**
 * Universal Date Formatter for Eastern Credit Union
 * Consistently formats dates across all views to: "Oct 27, 2026 14:32:05" (MMM DD, YYYY HH:MM:SS)
 */

export function formatDate(val) {
  if (!val) return "N/A";
  const dt = new Date(val);
  if (isNaN(dt.getTime())) return String(val);

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const m = months[dt.getMonth()];
  const d = String(dt.getDate()).padStart(2, "0");
  const y = dt.getFullYear();
  const hh = String(dt.getHours()).padStart(2, "0");
  const mm = String(dt.getMinutes()).padStart(2, "0");
  const ss = String(dt.getSeconds()).padStart(2, "0");

  return `${m} ${d}, ${y} ${hh}:${mm}:${ss}`;
}

export function formatDateOnly(val) {
  if (!val) return "N/A";
  const dt = new Date(val);
  if (isNaN(dt.getTime())) return String(val);

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const m = months[dt.getMonth()];
  const d = String(dt.getDate()).padStart(2, "0");
  const y = dt.getFullYear();

  return `${m} ${d}, ${y}`;
}

export function formatTimeOnly(val) {
  if (!val) return "";
  const dt = new Date(val);
  if (isNaN(dt.getTime())) return "";

  const hh = String(dt.getHours()).padStart(2, "0");
  const mm = String(dt.getMinutes()).padStart(2, "0");
  const ss = String(dt.getSeconds()).padStart(2, "0");

  return `${hh}:${mm}:${ss}`;
}

export default {
  formatDate,
  formatDateOnly,
  formatTimeOnly,
};
